import Dexie from 'dexie'
import { databaseId } from '@/store/main'
import { Slide } from '@/types/slides'
import { LOCALSTORAGE_KEY_DISCARDED_DB } from '@/configs/storage'

export interface Snapshot {
  index: number;
  slides: Slide[];
}

const databaseNamePrefix = 'PPTist'

// 删除数据
export const deleteTableAllData = async () => {
  const databaseNames = await Dexie.getDatabaseNames()

  const discardedDBNames = databaseNames.filter(name => {
    if (name.indexOf(databaseNamePrefix) === -1) return false    
    return true
  })
  for (const name of discardedDBNames) Dexie.delete(name)
}

// 删除失效/过期的数据库
// 应用关闭时（关闭或刷新浏览器），会将其数据库ID记录在 localStorage 中，表示该ID指向的数据库已失效
// 当应用初始化时，检查当前所有数据库，将被记录失效的数据库删除
// 另外，距离初始化时间超过12小时的数据库也将被删除（这是为了防止出现因以外未被正确删除的库）
export const deleteDiscardedDB = async (useDB: string) => {
  const now = new Date().getTime()

  const localStorageDiscardedDB = localStorage.getItem(LOCALSTORAGE_KEY_DISCARDED_DB)
  const localStorageDiscardedDBList: string[] = localStorageDiscardedDB ? JSON.parse(localStorageDiscardedDB) : []

  const databaseNames = await Dexie.getDatabaseNames()

  const discardedDBNames = databaseNames.filter(name => {
    if (name.indexOf(databaseNamePrefix) === -1) return false
    
    const [prefix, id, time] = name.split('_')
    if (prefix !== databaseNamePrefix || !id || !time) return true
    if (localStorageDiscardedDBList.includes(id)) return true
    if (now - (+time) >= 1000 * 60 * 60 * 12) return true
    if (useDB !== '' && name !== useDB) return true

    return false
  })
  for (const name of discardedDBNames) Dexie.delete(name)
  localStorage.removeItem(LOCALSTORAGE_KEY_DISCARDED_DB)
}

// 提取时间戳的辅助函数，具体实现根据实际情况调整
function extractTimestamp(name: string): number {
  // 假设时间戳在名称的末尾，并且是数字形式
  const timestamp = name.match(/\d+$/)
  return timestamp ? parseInt(timestamp[0], 10) : 0
}

// 检查之前的数据库,输出最后一条记录
export const lastTimeData = async () => {
  // debugger
  const databaseNames = await Dexie.getDatabaseNames()
  const lastDBName = databaseNames.filter(name => name.indexOf(databaseNamePrefix) !== -1).sort((a, b) => {
    // 假设时间戳在名称的某个部分，可以提取出来进行比较
    const timestampA = extractTimestamp(a)
    const timestampB = extractTimestamp(b)
    return timestampA - timestampB // 倒序排序
  }).pop()
  // 连接lastDBName数据库
  const dbLast = new Dexie(lastDBName || '')
  // 定义表结构
  // 之所以需要再次定义表结构，是因为在连接到一个已存在的数据库时，必须明确数据库的结构，以便能够正确地访问和操作其中的数据。即使数据库已经存在，仍然需要通过 version 和 stores 方法来告诉 Dexie 数据库的表结构和索引。
  dbLast.version(1).stores({
    snapshots: '++id',
  })
  // 获取snapshots表的最后一条数据
  const dbcount = await dbLast.table('snapshots').count()
  if (dbcount === 0) return []
  // 获取lastData数据最后一条记录
  const lastData = await dbLast.table('snapshots').offset(dbcount - 1).toArray()
  if (lastData.length === 0) return []

  return {name: lastDBName, data: lastData}
}

class PPTistDB extends Dexie {
  public snapshots: Dexie.Table<Snapshot, number>

  public constructor() {
    super(`${databaseNamePrefix}_${databaseId}_${new Date().getTime()}`)
    this.version(1).stores({
      snapshots: '++id'
    })
    this.snapshots = this.table('snapshots')
  }

  public async lastData() {
    return await this.snapshots.toArray()
  }
}

export const db = new PPTistDB()